<template>
	<div class="upload_main">
		<div :class="{active_upload_main:tab == isActive}">
		<div class="upload_Header">
			<a href="http://www.pisx.com/" target="_blank">
				<img src="../../assets/img/logo/3dmodel.png" class="upload_logo">
			</a>
			<div class="upload_info">
				<button class="upload_backhome_btn" @click="HomeClik">返回首页</button>
				<button class="upload_exit_btn" @click="zhuxiao">退出登录</button>
				<img src="../../assets/img/upload/用户.png" class="upload_login_img">
				<span class="upload_login_name">{{loginnanme.toLowerCase()}}</span>
			</div>
		</div>
		<div class="upload_user">
			<div class="upload_user_left">
				<div class="upload_user_left_up">
					<img src="../../assets/img/upload/上传.png" class="upload_icon">我的上传文件（{{coumt_upload}}）
				</div>
				<div class="upload_tree">
					<el-tree :data="treeData" ref="tree" default-expand-all node-key="id" class="expand-tree"
						highlight-current :props="defaultProps" :expand-on-click-node="false" current-node-key="root"
						:filter-node-method="filterNode" @node-click="handleNodeClick">
					</el-tree>
				</div>
			</div>
			<div class="upload_user_right">
				<div class="upload_imformation">
					<img src="../../assets/img/upload/I.png" alt="" class="upload_I">
					<span class="mLeft10">请上传模型，上传后模型将自动转档，转档成功查看模型和分享模型查看</span>
				</div>
				<div class="upload_btn">
					<button class="upload_btn_Mupload" @click="isshowupload= true; isActive = true">上传模型</button>	
				</div>
				<div class="upload_uploadList">
						<div v-if="showlidata" class="upload_list_no">
							<ul>
								<li class="upload_imginfos">
									暂无数据，未上传模型，请上传模型，上传模型转换成功请点击子节点查看模型
								</li>
							</ul>
						</div>
						<div v-if="showlidataimage" class="mTop20">
							<ul>
								<li class="upload_model_imformation">
									<div class="upload_model_name">模型名称</div>
									<div class="upload_model_time">最近编辑/转档时间</div>
									<div class="upload_model_operation">操作</div>
				
								</li>
								<li class="upload_imginfos" v-for="item in modelists" :key="item.value">
									<div style="display: flex;width: 40%;">
										<viewer :images="modelists">
											<img :src="'data:image/png;base64,'+item.src" class="upload_model_img">
										</viewer>
										<div class="upload_model_filename">{{item.name}}</div>
									</div>
				
										
									<div class="upload_model_filetime">{{item.time}}</div>
									<div class="upload_file_btn"> 
									<button class="upload_lookmodel_btn" type="button"
											date-id="item.path" @click="btn_modelList(item.path)">查看模型</button>
									<button class="upload_sharemodel_btn" type="button" date-id="item.path" @click="qrCodeClick(item,$event)">二维码分享</button>
											
									</div>
								</li>
							</ul>
						</div>
						<div v-if="failchange" style="overflow-y: auto; height: 87%;">
							<ul>
								<li class="upload_change_imformation" style="justify-content: center">
									模型转换失败，请重新上传可支持的模型文件
								</li>
							</ul>
						</div>
				</div>
			</div>
		</div>
		</div>
		<div class="upload_model_file" v-if="isshowupload">
			<!-- <div class="upload_close_btn">
				<img src="../../assets/img/关闭.png" @click="close" class="img_close">
			</div> -->
			<div class="upload_Tips">
				<span class="mLeft20">上传模型</span>
				<hr>
			</div>
			<div>
				<ul class="upload-rules">
					<span>文件上传格式提示：</span>
					<li>请将模型文件打包成一个zip文件，zip文件名以装配体名称命名，zip压缩文件大小50MB</li>
					<li>普通用户只能上传5个模型文件</li>
					<!-- <li>支持格式：STEP，Creo，NX，Catia，SolidWorks，SolidEdge，Inventor</li> -->
					<li>支持格式：.stp，step，.asm，.prt，.catpart，.catproduct，iam，ipt，.sldprt，.sldasm</li>
					<!-- <li>支持格式：.stp，step，.asm，.prt，.catpart，.catproduct，iam，ipt，.sldprt，.sldasm，.par，.psm，.Z3ASM</li> -->	
				</ul>
			</div>
			<div class="upload_select_T">
				<div class="upload_drag-area" @dragover="fileDragover" @drop="fileDrop">
					<div v-if="fileName" class="upload_file-name">{{ fileName }}</div>
					<div v-else class="upload_uploader-tips">
						<i><img src="../../assets/img/导入.png" class="upload_Import_icon"></i>
						<span>将文件拖拽至此，或</span>
						<label for="fileInput" style="color: #11A8FF; cursor: pointer">点此上传</label>

					</div>
				</div>
				<div>
					<input type="file" id="fileInput" @change="chooseUploadFile" style="display: none;">
					<label for="fileInput" v-if="fileName" class="upload_select_file">
						选择文件
					</label>
					
					<div class="upload_progress-wrap">
						<p class="upload_progress"><span :style="style">{{progressBar+'%'}}</span></p>
					</div>
					<div class="upload_user_model_btn">
						<button @click="submit" class="upload_user_upload_btn">上传</button>
						<button @click="close" class="upload_user_upload_btn">取消</button>
					</div>
				</div>

			</div>
		</div>
		<div v-if="loadingShow"
				v-loading="loading"
				element-loading-text="模型转换中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)"
				style="width: 100%; height: 100%;" >
			
		</div>
		<el-dialog title="扫码查看模型" :visible.sync="QRCodeShow" @opened="qrCodeCreate" width="14%"  class="canvas">
			<div id="qrCode">
				<div id="code"></div>
				<canvas id="canvas"></canvas>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import QRCode from 'qrcode'
	export default {
		data() {
			return {
				file: '', //上传对象
				progressBar: 0, // 记录上传进度的变量
				fileName: '',
				batchFile: '',
				MAX_FILE_SIZE: 50 * 1000 * 1000,
				extarr: 'zip',
				loginnanme: '',
				isshowupload: false,
				treedata: {},
				fielitemdata: '',
				coumt_upload: '0',
				filterText: '',
				mtime: '',
				treeData: [{
					id: 'root',
					label: this.cookie.getCookie("loginname").toLowerCase(),
					children: []
				}],
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				srcs: [],
				fileListS: [],
				modelists: [],
				showlidataimage: false,
				showlidata: true,
				tab: true,
				isActive: false,
				network: true, //默认有网
				QRCodeShow : false,
				qrTexxt : '',
				loading: true,
				loadingShow: false,
				num: 8,
				timer: null,
				upfile: '',
				failchange: false,
				upfilename: ''
			}
		},
		destroyed(){
			clearInterval(this.timer);
			this.timer = null
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			}
		},
		computed: {
			style() { // 进度条样式
				return {
					width: this.progressBar + "%"
				}
			}
		},
		mounted() {
			this.loginnanme = this.cookie.getCookie("loginname").toLowerCase();
			var that = this;
			// 监听浏览器是否关闭
			window.addEventListener("beforeunload", e => that.browerStatus());
			window.addEventListener("offline", () => {
				// console.log("已断网");
				this.network = false;
			});
			window.addEventListener("online", () => {
				// console.log("网络已连接");
				this.network = true;
			});
		},
		methods: {
			stop() {
				clearInterval(this.timer);
				this.timer = null;
			},
			getProjectList(){
				// this.$axios.get("http://localhost:8088/api/changemodel", {
				this.$axios.get("http://internal.pisx.com:8012/api/changemodel", {
						params: {
							loginname: this.cookie.getCookie("loginname").toLowerCase(),
							filename: this.upfile,
						},
					})
					.then((res) => {
						if(res.data.status == '转档成功') {
							// console.log(res.data.msg)
							// clearInterval(this.timer);
							this.stop();
							this.isshowupload = false;
							this.loadingShow = false;
							this.isActive = false,
							this.$message({
								message: '模型转档成功，请查看模型!',
								type: 'success',
								duration: '1000',
								showClose: true
							});
							// this.$axios.get("http://localhost:8088/api/uploadfile", {
							this.$axios.get("http://internal.pisx.com:8012/api/uploadfile", {
									params: {
										loginname: this.cookie.getCookie("loginname").toLowerCase(),
									}
								})
								.then((res) => {
									let newList = [];
									for (let i = 0; i < res.data.item.length; i++) {
										newList[i] = {
											id: res.data.item[i],
											label: res.data.item[i],
										};
									}
									this.treeData[0].children = newList;
									this.coumt_upload = res.data.length;
									this.$nextTick(function(){
										this.$refs['tree'].setCurrentKey(this.upfilename);
									})
									// this.$axios.get("http://localhost:8088/api/fileitem", {
									this.$axios.get("http://internal.pisx.com:8012/api/fileitem", {
											params: {
												loginname: this.cookie.getCookie("loginname").toLowerCase(),
												filename_item: this.upfilename,
											},
										})
										.then((res) => {
											console.log(res.data[0].unique.length)
											
											if(res.data[0].unique.length >0 ){
												this.showlidata = false
												this.failchange = false
												this.showlidataimage = true
												var modelists = []
												for (var i = 0; i < res.data[0].unique.length; i++) {
													let nameList = res.data[0].modename[i];
													let name = nameList.substring(nameList.lastIndexOf("/") + 1)
													// console.log(res.data[0])
													let time_test = this.$moment(res.data[0].stattime[i]).format('YYYY-MM-DD HH:mm:ss');
													// console.log("===" + time_test)
													modelists.push({
														src: res.data[0].unique[i],
														name: name + '.piv',
														time: time_test,
														path: nameList + '.piv'
													})
													// console.log(res.data[0].stattime[i])
													
												}
												this.modelists = modelists
												this.$refs.container.scrollTop = 0
											}else{
												
												this.failchange= true
												this.showlidata = false
												this.showlidataimage = false
												this.$refs.container.scrollTop = 0
											}
											
										})
										.catch((error) => {
											// console.log(error)
										})
								})
								.catch((error) => {
									// console.log(error)
								})
						}else if(res.data.status == '转档失败') {
							// console.log(res.data.msg)
							// clearInterval(this.timer);
							this.stop();
							this.isshowupload = false;
							this.loadingShow = false;
							this.isActive = false,
							this.$message({
								message: '模型转档失败!',
								type: 'error',
								duration: '1000',
								showClose: true
							});
							// this.$axios.get("http://localhost:8088/api/uploadfile", {
							this.$axios.get("http://internal.pisx.com:8012/api/uploadfile", {
									params: {
										loginname: this.cookie.getCookie("loginname").toLowerCase(),
									}
								})
								.then((res) => {
									let newList = [];
									for (let i = 0; i < res.data.item.length; i++) {
										newList[i] = {
											id: res.data.item[i],
											label: res.data.item[i],
										};
									}
									// console.log(this.treeData)
									this.treeData[0].children = newList;
									this.coumt_upload = res.data.length;
									// this.$nextTick(function(){
									// 	this.$refs['tree'].setCurrentKey(this.upfilename);
									// });
									// // this.$axios.get("http://localhost:8088/api/fileitem", {
									// this.$axios.get("http://internal.pisx.com:8012/api/fileitem", {
									// 		params: {
									// 			loginname: this.cookie.getCookie("loginname").toLowerCase(),
									// 			filename_item: this.upfilename,
									// 		},
									// 	})
									// 	.then((res) => {
									// 		console.log(res.data[0].unique.length)
											
									// 		if(res.data[0].unique.length >0 ){
									// 			this.showlidata = false
									// 			this.failchange = false
									// 			this.showlidataimage = true
									// 			var modelists = []
									// 			for (var i = 0; i < res.data[0].unique.length; i++) {
									// 				let nameList = res.data[0].modename[i];
									// 				let name = nameList.substring(nameList.lastIndexOf("/") + 1)
									// 				// console.log(res.data[0])
									// 				let time_test = this.$moment(res.data[0].stattime[i]).format('YYYY-MM-DD HH:mm:ss');
									// 				// console.log("===" + time_test)
									// 				modelists.push({
									// 					src: res.data[0].unique[i],
									// 					name: name + '.piv',
									// 					time: time_test,
									// 					path: nameList + '.piv'
									// 				})
									// 				// console.log(res.data[0].stattime[i])
													
									// 			}
									// 			this.modelists = modelists
									// 			this.$refs.container.scrollTop = 0
									// 		}else{
												
									// 			this.failchange= true
									// 			this.showlidata = false
									// 			this.showlidataimage = false
									// 			this.$refs.container.scrollTop = 0
									// 		}
											
									// 	})
									// 	.catch((error) => {
									// 		// console.log(error)
									// 	})
								})
								.catch((error) => {
									// console.log(error)
								})
						}
					})
					.catch((error) => {
						// console.log(error)
					})
				
			},
			qrCodeClick(item, e){
				var imgsrc = item.path;
				// var ifname = imgsrc.substring(0, imgsrc.lastIndexOf('.'));
				// console.log(imgsrc)
				var qrTexxt = 'http://internal.pisx.com:8013/TundraViewer/dist/professional/index.html#../../..' + imgsrc
				this.qrTexxt = qrTexxt
				this.QRCodeShow = true;
				console.log(qrTexxt)
			},
			qrCodeCreate() {
				var _this = this;
				document.getElementById("canvas").innerHTML = ""; // 每次加载，元素清空
				var canvas = document.getElementById("canvas");
				// 将属性拼接字符串即可
				var test = this.qrTexxt;
				QRCode.toCanvas(canvas, test, function(error) {
					if (error) console.error(error);
					//console.log("QRCode success!");
				});
			},
			qrCodeHandleClose() { //关闭弹窗
				this.QRCodeShow = false;
			},
			open() { // 打开弹窗
				this.QRCodeShow = true;
			},
			btn_modelList(path) {
				var path_info = path.substr(path.indexOf('upload'));
				var modelSrc =
					'http://internal.pisx.com:8013/TundraViewer/dist/professional/index.html#../../..' +
					path
				window.open(modelSrc, '_blank')
				// console.log(path)
			},
			handleNodeClick(treeData, e) {
				// console.log(treeData)
				if (treeData.label == this.cookie.getCookie("loginname").toLowerCase()) {
					this.showlidata = true
					this.showlidataimage = false
					this.failchange = false
				} else {
					// this.$axios.get("http://localhost:8088/api/fileitem", {
					this.$axios.get("http://internal.pisx.com:8012/api/fileitem", {
							params: {
								loginname: this.cookie.getCookie("loginname").toLowerCase(),
								filename_item: treeData.label,
							},
						})
						.then((res) => {

							var modelists = []
							if(res.data[0].unique.length >0 ){
								this.showlidata = false
								this.failchange = false
								this.showlidataimage = true
								for (var i = 0; i < res.data[0].unique.length; i++) {
									let nameList = res.data[0].modename[i];
									let name = nameList.substring(nameList.lastIndexOf("/") + 1)
									// console.log(res.data[0].stattime[i])
									let time_test = this.$moment(res.data[0].stattime[i]).format('YYYY-MM-DD HH:mm:ss');
									// console.log("===" + time_test)
									modelists.push({
										src: res.data[0].unique[i],
										name: name + '.piv',
										time: time_test,
										path: nameList + '.piv'
									})
									// console.log(res.data[0].stattime[1])
									// console.log(res.data[0].modename[i])
								}
								this.modelists = modelists
								this.$refs.container.scrollTop = 0
							}else{
								
								this.failchange= true
								this.showlidata = false
								this.showlidataimage = false
								this.$refs.container.scrollTop = 0
							}
						})
						.catch((error) => {
							// console.log(error)
						})
				}

			},
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			close() {
				this.isActive = false,
				this.isshowupload = false,
				this.file = '',
				this.batchFile = '',
				this.fileName = '',
				this.progressBar = 0
				this.stop();
			},
			browerStatus() {
				var that = this;
				this.cookie.clearCookie("loginname")
			},
			zhuxiao() {
				this.cookie.clearCookie("loginname")
				this.stop()
				this.$router.push({
					path: '/home'
				}).catch(() => {})
			},
			HomeClik() {
				this.$router.push({
					path: '/home'
				}).catch(() => {})
			},
			// 点击上传
			chooseUploadFile(e) {
				const file = e.target.files.item(0);

				const index = file.name.lastIndexOf(".");

				const ext = file.name.substr(index + 1).toLowerCase();

				const extarr = ['zip']

				if (!file) return
				if (file.size > this.MAX_FILE_SIZE) {

					return this.$message({
						message: '文件大小不能超过50M',
						type: 'error',
						duration: '1000',
						showClose: true
					})
				}
				if (extarr.indexOf(ext) == -1) {
					return this.$message({
						message: '文件格式不正确,仅支持zip格式',
						type: 'error',
						duration: '1000',
						showClose: true
					})
				}

				this.batchFile = file
				this.fileName = file.name

				// 清空，防止上传后再上传没有反应
				e.target.value = ''
			},
			// 拖拽上传
			fileDragover(e) {
				e.preventDefault()
			},
			fileDrop(e) {
				e.preventDefault()
				const file = e.dataTransfer.files[0] // 获取到第一个上传的文件对象
				const index = file.name.lastIndexOf(".");

				const ext = file.name.substr(index + 1).toLowerCase();

				const extarr = ['zip']
				if (!file) return
				if (file.size > this.MAX_FILE_SIZE) {
					return this.$message({
						message: '文件大小不能超过50M',
						type: 'error',
						duration: '1000',
						showClose: true
					})
				}
				if (extarr.indexOf(ext) == -1) {
					return this.$message({
						message: '文件格式不正确,仅支持zip格式',
						type: 'error',
						duration: '1000',
						showClose: true
					})
				}

				this.batchFile = file
				this.fileName = file.name
			},
			fileSelect(e) {
				this.batchFile = e.target.files[0]
			},
			async submit() {
				if (this.batchFile == '') {
					// this.$message.warning('请上传文件');
					this.$message({
						message: '请选择上传文件',
						type: 'error',
						duration: '1000',
						showClose: true
					})
				} 
				else if(this.coumt_upload >= 5){
					this.$message({
						message: '只能转档5个模型文件!',
						type: 'error',
						duration: '1000',
						showClose: true
					})
				}
				else {
					const formData = new FormData();
					formData.append('loginname', this.cookie.getCookie("loginname").toLowerCase());
					formData.append('file', this.batchFile);
					// console.log(formData.get('loginname'))
					// await this.$axios.post('http://localhost:8088/api/upload', formData, {
					await this.$axios.post('http://internal.pisx.com:8012/api/upload', formData, {
							onUploadProgress: (progressEvent) => {
								var percentCompleted = Math.round((progressEvent.loaded * 100) /
									progressEvent
									.total);
								this.progressBar = percentCompleted
							}
						})
						.then(res => {
							// this.$message.success('上传成功')
							
							this.upfile = res.data.path
							this.upfilename = res.data.path.substring(0,res.data.path.lastIndexOf('.zip'))
							if (res.data.status == 0 && this.progressBar == 100)
								this.$message({
									message: res.data.msg,
									type: 'success',
									duration: '1000',
									showClose: true
								}),
								this.showupload = false,
								this.loadingShow = true,
								this.file = '',
								// this.batchFile = '',
								this.fileName = '',
								this.progressBar = 0,
								this.batchFile = '',
								this.timer = setInterval(() =>{
									setTimeout(this.getProjectList(), 0);
								},2000);
								// this.isActive = false,
								// this.$axios.get("http://localhost:8088/api/uploadfile", {
								this.$axios.get("http://internal.pisx.com:8012/api/uploadfile", {
									params: {
										loginname: this.cookie.getCookie("loginname").toLowerCase(),
									}
								})
								.then((res) => {
									this.treedata = res.data;
									// console.log("===++++" + res.data)
								})
								.catch((error) => {
									// console.log(error)
								})
						})
						.catch(err => {
							if (this.network == false) {
								// console.log("++++++" + this.network)
								this.$message({
									message: '上传失败',
									type: 'error',
									duration: '1000',
									showClose: true,

								})
								this.progressBar = 0
								this.isshowupload = false
								this.isActive = false
								this.file = ''
								this.batchFile = ''
								this.fileName = ''
							}

						})
				}

			},
			changeFile() {
				this.batchFile = this.$refs.file.files[0];
			}
		},
		created: function() {
			this.$emit('FootItem', false);
			// this.$axios.get("http://localhost:8088/api/uploadfile", {
			this.$axios.get("http://internal.pisx.com:8012/api/uploadfile", {
					params: {
						loginname: this.cookie.getCookie("loginname").toLowerCase(),
					}
				})
				.then((res) => {
					let newList = [];
					for (let i = 0; i < res.data.item.length; i++) {
						newList[i] = {
							id: res.data.item[i],
							label: res.data.item[i],
						};
					}
					this.treeData[0].children = newList;
					this.coumt_upload = res.data.length
				})
				.catch((error) => {
					// console.log(error)
				})
		}
	}
</script>

<style>
</style>
